import ReportDesignerCellDetailDialog from './cellDetailDialog'
import ReportTemplateOpenDialog from './openDialog'
import ChangeParentDialog from '@/components/reportDesigner/dialogs/changeParentDialog'

export const reportDesignerDialogs = {
  reportTemplateOpenDialog: ReportTemplateOpenDialog,
  reportDesignerCellDetailDialog: ReportDesignerCellDetailDialog,
  reportDesignerChangeParentDialog: ChangeParentDialog
}



// WEBPACK FOOTER //
// ./src/components/reportDesigner/dialogs/index.js